<input
    #input
    type="number"
    class="ag-input-field-input ag-text-field-input"
    (keydown)="onKeyDown($event)"
    [(ngModel)]="value"
    aria-label="Max Length"
/>